<template>
    <div class="wrapper-div">
        <div
            class="locations-all-dialog extend-bottom"
            :style="{ 'max-width': width + 'px' }"
        >
            <div style="position: relative; top: 5px; right: 20px;">
                <IconBtn
                    class="primary-outlined closeBtnWrapper"
                    @click="closeDialog"
                    name="times"
                    size="lg"
                    style="float: right;"
                />
            </div>
            <Paper
                style="width: 100%; margin-top: 42px;"
                :header="$t('companyDetail.locations.allLocations')"
                restrictHeaderWidth
            >
                <div class="pb-7 locations-all-layout">
                    <component
                        v-for="(item, index) in payload.items"
                        style="text-align: center;"
                        :key="index"
                        :is="getComponent()"
                        v-bind="item"
                    />
                </div>
            </Paper>
        </div>
    </div>
</template>

<script>
// TODO: Change Component used in grid from Carousel.Default to whatever the component for local company profiles will be (carousel component)
import CarouselDefault from '~/components/builders/Carousel.Default';

export default {
    name: 'Locations.All.Dialog',

    data() {
        return {
            width: 600,
        };
    },

    computed: {
        state() {
            return this.$interfaces.dialogModal.getState();
        },
        payload() {
            return this.state.payload;
        },
    },

    methods: {
        closeDialog() {
            this.state.resolver.res();
        },

        handleResizeEvent() {
            this.width = window.innerWidth;
        },

        getComponent() {
            return CarouselDefault;
        },
    },

    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.handleResizeEvent);
        });
        this.handleResizeEvent();
    },

    destroyed() {
        window.removeEventListener('resize', this.handleResizeEvent);
    },
};
</script>

<style lang="css" scoped>

.locations-all-dialog {
    max-width: var(--grid-width);
    width: var(--grid-width);
    margin: 0 auto;
}

.locations-all-layout {
    padding: 3em;
    display: grid;
    grid-gap: 20px;
    grid-template-columns: repeat(4, 1fr);
}

.wrapper-div {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
}

@media only screen and (max-width: 600px) {
    .locations-all-layout {
        grid-template-columns: 1fr;
        padding: 1em;
    }
}
</style>
